export const PAGE_LAYOUT_SLOTS = {
  HEADER: 'header',
  BODY: 'body',
  FOOTER: 'footer',
}

export const PAGE_LAYOUT_SLOT_NAMES = Object.values(PAGE_LAYOUT_SLOTS)
